<script setup lang="ts"></script>
<template>
  <p
    class="text-c-3 [&_code]:font-code [&_a:hover]:text-c-1 text-center leading-normal [&_a]:underline">
    <slot />
  </p>
</template>
